import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { ScrollableList } from './ScrollableList.js';
import { useListbox } from './useListbox.js';
import { useMultiListbox } from './useMultiListbox.js';

const Listbox = /*#__PURE__*/forwardRef(function Listbox(props, ref) {
  const {
    className: externalClassName,
    ...otherProps
  } = props;
  const {
    list,
    input
  } = useListbox(otherProps, ref);
  const className = cn('bg-white inline-flex relative w-full', externalClassName);
  return createElement("span", {
    "data-taco": "listbox",
    className: className
  }, createElement(ScrollableList, Object.assign({}, list, {
    style: { ...list.style,
      maxHeight: 'calc(12rem + 2px)'
      /* (6 * option height) + listbox border */

    }
  })), createElement("input", Object.assign({}, input, {
    className: "hidden",
    type: "text"
  })));
});
const MultiListbox = /*#__PURE__*/forwardRef(function Listbox(props, ref) {
  const {
    className: externalClassName,
    ...otherProps
  } = props;
  const {
    list,
    input
  } = useMultiListbox(otherProps, ref);
  const className = cn('bg-white inline-flex relative w-full', externalClassName);
  return createElement("span", {
    "data-taco": "listbox",
    className: className
  }, createElement(ScrollableList, Object.assign({}, list, {
    style: { ...list.style,
      maxHeight: 'calc(12rem + 2px + 2px)'
      /* (6 * option height) + listbox border + ALL_OPTIONS bottom border */

    }
  })), createElement("input", Object.assign({}, input, {
    className: "hidden",
    type: "text"
  })));
});

export { Listbox, MultiListbox };
//# sourceMappingURL=Listbox.js.map
